"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNanpUsOrCanadaNumber = exports.isSmsRecipientAllowed = void 0;
const phone_1 = require("phone");
const sms_sender_1 = require("./sms-sender");
const US_DOMESTIC_ISO2 = new Set(["US", "PR", "VI", "GU", "MP", "AS"]);
const isSmsRecipientAllowed = (phoneNumber, country) => {
    const result = (0, phone_1.phone)(phoneNumber);
    if (!result.isValid || !result.countryIso2) {
        return false;
    }
    if ((0, sms_sender_1.isUsSmsSenderCountry)(country)) {
        return US_DOMESTIC_ISO2.has(result.countryIso2);
    }
    if ((0, sms_sender_1.isCanadaSmsSenderCountry)(country)) {
        return result.countryIso2 === "CA";
    }
    return false;
};
exports.isSmsRecipientAllowed = isSmsRecipientAllowed;
const isNanpUsOrCanadaNumber = (phoneNumber) => {
    const result = (0, phone_1.phone)(phoneNumber);
    return (result.isValid &&
        result.countryIso2 !== null &&
        (US_DOMESTIC_ISO2.has(result.countryIso2) || result.countryIso2 === "CA"));
};
exports.isNanpUsOrCanadaNumber = isNanpUsOrCanadaNumber;
